import { render } from "./ModalSettings.vue?vue&type=template&id=479ea6c0&scoped=true"
import script from "./ModalSettings.vue?vue&type=script&lang=js"
export * from "./ModalSettings.vue?vue&type=script&lang=js"

import "./ModalSettings.vue?vue&type=style&index=0&id=479ea6c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479ea6c0"]])

export default __exports__